module.exports = "img/icons-groups.29180b0.svg";